//
// DO NOT EDIT this file directly.  Changes will be lost.
// Changes to static-data.json will be reflected here.
//
// This file is generated by apps/build/scripts/static-data/gen-static-data.mjs
//


import { Injectable } from "@angular/core";
import { AgreementtypeId, AwardkindId, AwardnameId, ContactMethodId, DecidingroleId, JobTriggerId, LanguageId, LmiBandId, MailgunEventTypeId, NotecategoryId, PhonetypeId, WeblinktypeId } from "../interfaces/static-enums";


interface Datum<ID> {
	id: ID,
	name: string,
}

export interface Agreementtype extends Datum<AgreementtypeId> {
}

export interface Awardkind extends Datum<AwardkindId> {
}

export interface Awardname extends Datum<AwardnameId> {
	order: number,
}

export interface ContactMethod extends Datum<ContactMethodId> {
	canBeDefaultContactMethod: boolean,
}

export interface Decidingrole extends Datum<DecidingroleId> {
}

export interface JobTrigger extends Datum<JobTriggerId> {
}

export interface Language extends Datum<LanguageId> {
}

export interface LmiBand extends Datum<LmiBandId> {
}

export interface MailgunEventType extends Datum<MailgunEventTypeId> {
}

export interface Notecategory extends Datum<NotecategoryId> {
}

export interface Phonetype extends Datum<PhonetypeId> {
}

export interface Weblinktype extends Datum<WeblinktypeId> {
}


class StaticData<ID, DATUM extends Datum<ID>> {

	private _byId: Map<ID, DATUM>;

	constructor(private data: DATUM[]) {
		this._byId = new Map<ID, Readonly<DATUM>>(this.data.map(obj => [obj.id, obj]));
	}

	public byId(id: ID): Readonly<DATUM>;
	public byId(id: undefined): undefined;
	public byId(id: ID | undefined): Readonly<DATUM> | undefined {
		if (id == undefined) return undefined;
		return this._byId.get(id);
	}

	/** Returns all items sorted per the sortColumn in the static-data.json file */
	public get all(): Readonly<DATUM[]> {
		return this.data;
	}
}

/**
 * To change the StaticDataService, adjust static-data.json and rerun the generator.
 */
@Injectable({ providedIn: 'root' })
export class StaticDataService {

	public readonly agreementtypes = new StaticData<AgreementtypeId, Agreementtype>([
		{ id: AgreementtypeId.EforallEntrepreneurHandbook, name: 'EforAll Entrepreneur Handbook' },
		{ id: AgreementtypeId.EforallLeadershipAdvisoryCouncilHandbook, name: 'EforAll Leadership Advisory Council Handbook' },
		{ id: AgreementtypeId.EforallMentorHandbook, name: 'EforAll Mentor Handbook' },
		{ id: AgreementtypeId.MediaConsentAgreement, name: 'Media Consent Agreement' },
	]);

	public readonly awardKinds = new StaticData<AwardkindId, Awardkind>([
		{ id: AwardkindId.MoneyFromEforall, name: 'Money from EforAll' },
		{ id: AwardkindId.MoneyFromSponsor, name: 'Money from Sponsor' },
		{ id: AwardkindId.InKindServices, name: 'In-Kind Services' },
	]);

	public readonly awardnames = new StaticData<AwardnameId, Awardname>([
		{ id: AwardnameId.Place1Award, name: 'Place #1 Award', order: 1 },
		{ id: AwardnameId.Place2Award, name: 'Place #2 Award', order: 1 },
		{ id: AwardnameId.Place3Award, name: 'Place #3 Award', order: 1 },
		{ id: AwardnameId.Place4Award, name: 'Place #4 Award', order: 1 },
		{ id: AwardnameId.Place5Award, name: 'Place #5 Award', order: 1 },
		{ id: AwardnameId.AudienceChoiceAward, name: 'Audience Choice Award', order: 2 },
		{ id: AwardnameId.AwardFromSponsor, name: 'Award from Sponsor', order: 3 },
		{ id: AwardnameId.QuarterlyQ2Award, name: 'Quarterly Q2 Award', order: 10 },
		{ id: AwardnameId.QuarterlyQ3Award, name: 'Quarterly Q3 Award', order: 10 },
		{ id: AwardnameId.QuarterlyQ4Award, name: 'Quarterly Q4 Award', order: 10 },
		{ id: AwardnameId.ChristinaHamiltonAward, name: 'Christina Hamilton Award', order: 20 },
		{ id: AwardnameId.HectorCondeAward, name: 'Hector Conde Award', order: 20 },
		{ id: AwardnameId.PaulaBuxbaumAward, name: 'Paula Buxbaum Award', order: 20 },
		{ id: AwardnameId.DanaFarberAward, name: 'Dana Farber Award', order: 20 },
	]);

	public readonly contact_methods = new StaticData<ContactMethodId, ContactMethod>([
		{ id: ContactMethodId.PhoneCall, name: 'Phone Call', canBeDefaultContactMethod: true },
		{ id: ContactMethodId.VideoCall, name: 'Video Call', canBeDefaultContactMethod: true },
		{ id: ContactMethodId.Email, name: 'Email', canBeDefaultContactMethod: true },
		{ id: ContactMethodId.Text, name: 'Text', canBeDefaultContactMethod: true },
		{ id: ContactMethodId.InPerson, name: 'In Person', canBeDefaultContactMethod: false },
		{ id: ContactMethodId.Whatsapp, name: 'WhatsApp', canBeDefaultContactMethod: true },
		{ id: ContactMethodId.GoogleChat, name: 'Google Chat', canBeDefaultContactMethod: true },
	]);

	public readonly decidingroles = new StaticData<DecidingroleId, Decidingrole>([
		{ id: DecidingroleId.Judge, name: 'Judge' },
		{ id: DecidingroleId.Audience, name: 'Audience' },
		{ id: DecidingroleId.Sponsor, name: 'Sponsor' },
		{ id: DecidingroleId.Staff, name: 'Staff' },
		{ id: DecidingroleId.LocalAdvisoryCouncil, name: 'Local Advisory Council' },
	]);

	public readonly job_triggers = new StaticData<JobTriggerId, JobTrigger>([
		{ id: JobTriggerId.AbandonedApplicationNotice, name: 'Abandoned Application Notice' },
		{ id: JobTriggerId.AcceleratorSeatAcceptedReminder, name: 'Accelerator Seat Accepted Reminder' },
		{ id: JobTriggerId.AcceleratorSeatOfferedNudge, name: 'Accelerator Seat Offered Nudge' },
		{ id: JobTriggerId.ApplicationDeferedForNextTrimesterNotice, name: 'Application Defered for Next Trimester Notice' },
		{ id: JobTriggerId.ApplicationDeferedNotice, name: 'Application Defered Notice' },
		{ id: JobTriggerId.ApplicationUnderReviewReminder, name: 'Application Under Review Reminder' },
		{ id: JobTriggerId.DeniedApplicationNotice, name: 'Denied Application Notice' },
		{ id: JobTriggerId.ElearningNudge, name: 'eLearning Nudge' },
		{ id: JobTriggerId.EntrepreneurNewAccountReminder, name: 'Entrepreneur: New Account Reminder' },
		{ id: JobTriggerId.JoinClassLinkEmail, name: 'Join class link email' },
		{ id: JobTriggerId.MissedApplicationDeadlineNotice, name: 'Missed Application Deadline Notice' },
		{ id: JobTriggerId.SubmittedApplicationNotice, name: 'Submitted Application Notice' },
		{ id: JobTriggerId.SurveyNudge, name: 'Survey Nudge' },
		{ id: JobTriggerId.TakeClassSurvey, name: 'Take Class Survey' },
		{ id: JobTriggerId.TeamAnnouncementForEntrepreneurs, name: 'Team Announcement for Entrepreneurs' },
		{ id: JobTriggerId.TeamAnnouncementForVolunteers, name: 'Team Announcement for Volunteers' },
		{ id: JobTriggerId.UnsubmittedApplicationNudge, name: 'Unsubmitted Application Nudge' },
		{ id: JobTriggerId.VolunteerNewAccountReminder, name: 'Volunteer: New Account Reminder' },
		{ id: JobTriggerId.WithdrawnApplicationNotice, name: 'Withdrawn Application Notice' },
	]);

	public readonly languages = new StaticData<LanguageId, Language>([
		{ id: LanguageId.English, name: 'English' },
		{ id: LanguageId.Espanol, name: 'Español' },
	]);

	public readonly lmi_bands = new StaticData<LmiBandId, LmiBand>([
		{ id: LmiBandId.VeryLow, name: 'Very Low' },
		{ id: LmiBandId.Low, name: 'Low' },
		{ id: LmiBandId.ModerateToHigh, name: 'Moderate to High' },
		{ id: LmiBandId.Historic, name: 'Historic' },
	]);

	public readonly mailgun_event_types = new StaticData<MailgunEventTypeId, MailgunEventType>([
		{ id: MailgunEventTypeId.Queued, name: 'queued' },
		{ id: MailgunEventTypeId.Delivered, name: 'delivered' },
		{ id: MailgunEventTypeId.Failed, name: 'failed' },
		{ id: MailgunEventTypeId.Opened, name: 'opened' },
		{ id: MailgunEventTypeId.Clicked, name: 'clicked' },
	]);

	public readonly notecategorys = new StaticData<NotecategoryId, Notecategory>([
		{ id: NotecategoryId.General, name: 'General' },
		{ id: NotecategoryId.RedFlag, name: 'Red Flag' },
		{ id: NotecategoryId.Press, name: 'Press' },
		{ id: NotecategoryId.FunFact, name: 'Fun Fact' },
		{ id: NotecategoryId.Program, name: 'Program' },
		{ id: NotecategoryId.FormerStaff, name: 'Former Staff' },
	]);

	public readonly phonetypes = new StaticData<PhonetypeId, Phonetype>([
		{ id: PhonetypeId.Landline, name: 'Landline' },
		{ id: PhonetypeId.Mobile, name: 'Mobile' },
		{ id: PhonetypeId.MobileDoNotText, name: 'Mobile - DO NOT TEXT' },
		{ id: PhonetypeId.International, name: 'International' },
	]);

	public readonly weblinktypes = new StaticData<WeblinktypeId, Weblinktype>([
		{ id: WeblinktypeId.Website, name: 'Website' },
		{ id: WeblinktypeId.Facebook, name: 'Facebook' },
		{ id: WeblinktypeId.Linkedin, name: 'LinkedIn' },
		{ id: WeblinktypeId.Twitter, name: 'Twitter' },
	]);

}
